import type {ModelFilterTechnicalDataGroup} from '@volkswagen-onehub/car-technical-details-bff';
import {Tabs} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import {resolveDataGroupName} from '../../utils/resolveDataGroupName';
import {useTranslate} from '../../utils/translate';
import {useTrackingService} from '../../utils/useTrackingService';
import {getFilterEntriesOfVariation, getFilter} from '../getFilter';
import {MultiTable, type MultiTableProps} from './multiTable';

/**
 * Convert to group that only contains variation matching to one of current
 * filter entries.
 */
function filteredGroup(
  group: ModelFilterTechnicalDataGroup,
  filterEntries: string[],
  modelFilterName: string,
  filterTitle: string,
) {
  const variations = group.variations.filter((variation) => {
    return filterEntries.find((filterEntry) =>
      getFilterEntriesOfVariation(variation, modelFilterName).includes(
        filterEntry,
      ),
    );
  });

  return {
    ...group,
    variations,
    filterTitle,
  };
}

export const MultiTableWithFilter = (props: MultiTableProps): JSX.Element => {
  const [tabIndex, setTabIndex] = React.useState(0);
  const tracking = useTrackingService();
  const translate = useTranslate();
  const groupName = resolveDataGroupName(props.group, translate);

  const filter = getFilter(props.group);

  // return table if there is no filter or just one value to select
  if (filter === undefined || filter.filterEntryList.length <= 1) {
    return <MultiTable group={props.group} />;
  }

  // create table for each filter value
  const tables = filter.filterEntryList
    .map((filterEntries) => {
      const filterLabel = filterEntries.join(', ');
      return filteredGroup(
        props.group,
        filterEntries,
        filter.modelFilterName,
        filterLabel,
      );
    })
    .filter((group) => group.variations.find((v) => v.values.length > 0))
    .map((group) => {
      return {
        key: group.filterTitle,
        title: group.filterTitle,
        content: <MultiTable group={group} />,
      };
    });

  return (
    <Tabs
      defaultIndex={tabIndex}
      onChange={(index) => {
        setTabIndex(index);
        tracking.trackContentTabClick(groupName, tables[index].title);
      }}
      idPrefix={''}
      scrollable
    >
      {tables}
    </Tabs>
  );
};
